
/**@param {Object} options*/
export function ChiliCommentsReCaptcha (options){

    if(!new.target){
        return new ChiliCommentsReCaptcha(options);
    }

    this.options = options;

    this.widgetId = null;

    let captchaSolved = false;

    let eventListeners = {};

    this.addEventListener = (event, listener) => {

        if (!eventListeners[event]) {
            eventListeners[event] = [];
        }

        eventListeners[event].push(listener);
    }

    this.emit = (event, data)  => {
        if (eventListeners[event]) {
            eventListeners[event].forEach((listener) => {
                if(typeof listener === "function"){
                    listener(data)
                }
            });
        }
    }

    /**@param {HTMLElement} form*/
    this.render = (form) => {

        if (!window.grecaptcha) {
            return;
        }

        let captchaContainer = form.querySelector('.captcha-container');

        if(this.widgetId !== null){
            window.grecaptcha.reset(this.widgetId);
        }
        else{

            if(!grecaptcha?.render && grecaptcha?.ready){
                grecaptcha.ready(()=>{
                    this.widgetId = grecaptcha.render(captchaContainer, {
                        sitekey: this.options.publicKey,
                        theme: 'light', // or 'dark'
                        size: 'normal', // or 'compact'
                        tabindex: 3,
                        callback: ()=>{
                            this.emit('captcha-success', {form: form});

                            if(this.isDependedCaptcha()){
                                this.render(form);
                            }
                        },
                        'expired-callback': ()=> {
                            this.emit('captcha-expired', {form: form});
                            this.render(form);
                        }, // optional callback function
                        'error-callback':  ()=> {
                           console.error(new Error('Recaptcha error'));
                        } // optional callback function
                    });
                });
            }

        }


    };

    /**@param {HTMLElement} form*/
    this.check = (form) => {

        // Мы можем принудительно вызвать проверку только для невидимой капчи

        if (!window.grecaptcha) {
            console.error('There are no Recaptcha library');
            return;
        }

        if(this.widgetId !== null ){
            if(this.options.invisible){
                return window.grecaptcha.execute({
                    widget_id: this.widgetId,
                    sitekey: this.options.publicKey
                });
            }
        }
        else{
            console.error('Widget ID not set');
        }
    }

    this.setPublicKey = (publicKey) => {
        this.options.publicKey = publicKey;
    }

    this.isDependedCaptcha = () => {
        return false;
    }


    return this;

}
